export function getBinderEssentials() {
    return  [
        {
            label: 'IRB Number',
            inputFieldType: 'single-value',
            name: 'irbNumber',
            dataType: 'small_text',
        },
        {
            label: 'Trial ID',
            inputFieldType: 'single-value',
            name: 'trialId',
            dataType: 'small_text',
        },
        {
            label: 'Trial Type',
            inputFieldType: 'single-value',
            name: 'trialType',
            dataType: 'small_text',
        },
        {
            label: 'Principal Investigator',
            inputFieldType: 'single-value',
            name: 'primaryInvestigator',
            dataType: 'small_text',
        },
        {
            label: 'Department / Site / DG',
            inputFieldType: 'single-value',
            name: 'departmentSiteDg',
            dataType: 'small_text',
        },
        {
            label: 'ClinicalTrials.gov Number',
            inputFieldType: 'single-value',
            name: 'ctGovNumber',
            dataType: 'small_text',
        },
        {
            label: 'Sponsor/CRO',
            inputFieldType: 'single-value',
            name: 'sponsorCro',
            dataType: 'small_text',
        },
        {
            label: 'Renewal Date',
            inputFieldType: 'date-value',
            name: 'renewalDate',
            dataType: 'dateonly',
        },
        {
            label: 'Contact',
            inputFieldType: 'single-value',
            name: 'contact',
            dataType: 'small_text',
        },
        {
            label: 'Description',
            inputFieldType: 'single-value',
            name: 'description',
            dataType: 'small_text',
        },
    ];
}

export function getBinderV4Essentials() {
    return  [
        {
            label: 'Sponsor',
            inputFieldType: 'single-value',
            name: 'sponsor',
            baseName: 'sponsor',
            old_baseName: 'sponsor',
            dataType: 'small_text',
        },
        {
            label: 'Protocol Number / Trial id',
            inputFieldType: 'single-value',
            name: 'trialId',
            baseName: 'trialId',
            old_baseName: 'trialId',
            dataType: 'small_text',
        },
        {
            label: 'Contact',
            inputFieldType: 'single-value',
            name: 'contact',
            baseName: 'contact',
            old_baseName: 'contact',
            dataType: 'small_text',
        },
        {
            label: 'CRO',
            inputFieldType: 'single-value',
            name: 'cro',
            baseName: 'cro',
            old_baseName: '',
            dataType: 'small_text',
        },
        {
            label: 'ClinicalTrials.gov Number',
            inputFieldType: 'single-value',
            name: 'ctGovNumber',
            baseName: 'ctGovNumber',
            old_baseName: 'ctGovNumber',
            dataType: 'small_text',
        },
        {
            label: 'Department',
            inputFieldType: 'single-value',
            name: 'department',
            baseName: 'department',
            old_baseName: 'department_site_dg',
            dataType: 'small_text',
        },
        {
            label: 'Disease Group',
            inputFieldType: 'single-value',
            name: 'diseaseGroup',
            baseName: 'diseaseGroup',
            old_baseName: 'department_site_dg',
            dataType: 'small_text',
        },
        {
            label: 'IRB / IEC Number',
            inputFieldType: 'single-value',
            name: 'irbIecNumber',
            baseName: 'irbIecNumber',
            old_baseName: 'irbIecNumber',
            dataType: 'small_text',
        },
        {
            label: 'Principal Investigator',
            inputFieldType: 'single-value',
            name: 'primaryInvestigator',
            baseName: 'primaryInvestigator',
            old_baseName: 'primaryInvestigator',
            dataType: 'small_text',
        },
        {
            label: 'Renewal Date',
            inputFieldType: 'date-value',
            name: 'renewalDate',
            baseName:  'renewalDate',
            old_baseName: 'renewalDate',
            dataType: 'dateonly',
        },        
        {
            label: 'Site',
            inputFieldType: 'single-value',
            name: 'site',
            baseName: 'site',
            old_baseName: '',
            dataType: 'small_text',
        },
        {
            label: 'Site Number',
            inputFieldType: 'single-value',
            name: 'siteNumber',
            baseName: 'siteNumber',
            old_baseName: '',
            dataType: 'small_text',
        },
    ];
}


export function getBinderEssentialsWithValues(binder) {
    return getBinderEssentials().map(essential =>
        ({...essential, value: binder[essential.name]})
    );
}
